module.exports = __webpack_public_path__ + "img/13.655be436.jpg";